

























import { Component, Prop, Vue} from 'vue-property-decorator';
import { JobDetail, Image, Company, Worker, Conversation } from '@/@types/LibraryComponent';

@Component
export default class OrganizationTooltip extends Vue {
  @Prop(Number) public avatarSize!: number;
  private job!: JobDetail;

}
